import { ERequestStatus } from './requestStatus';
import { ITextFieldState } from '../utils/postForm';

export enum EPostFormFieldName {
  Title = 'title',
}

export interface IPostFormFields {
  [EPostFormFieldName.Title]: ITextFieldState;
}

export interface IPostFrom {
  fields: IPostFormFields;
  formMessage: string;
  formStatus: ERequestStatus;
}
